import { type Option } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFetchEnterpriseContracts } from 'hooks/useFetchEnterpriseContracts';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/types';
import { type ContractRecordField } from 'types/enterprises';

export const useGetOptions = (): {
  contractId: Option[];
  contractRateId: Option[];
  recordFields: ContractRecordField[];
  isLoading: boolean;
} => {
  const { watch } = useFormContext();
  const { data: contracts, isLoading } = useFetchEnterpriseContracts();
  const contractId = watch(AppointmentsReservePayload.contractId);

  return useMemo(() => {
    const selectedContract = contracts?.find(contract => contract.id === Number(contractId));

    return {
      isLoading,
      contractId:
        contracts?.map(contract => ({
          value: String(contract.id),
          label: contract.title,
          description: contract.tenderNumber,
          ns: LOCIZE_NS.INSURANCE,
        })) ?? [],
      contractRateId:
        selectedContract?.rates?.map(rate => ({
          value: String(rate.id),
          label: rate.name,
          ns: LOCIZE_NS.INSURANCE,
        })) ?? [],
      recordFields: selectedContract?.recordFields ?? [],
    };
  }, [contracts, contractId, isLoading]);
};
